module.exports = __webpack_public_path__ + "img/loading_train.f7579f07.png";